import React from "react";

export const LocationMap = ({ lat, lng, label = "Auf OpenStreetMap öffnen" }) => {
  const d = 0.006;
  const bbox = `${lng - d}%2C${lat - d}%2C${lng + d}%2C${lat + d}`;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${lat}%2C${lng}`;
  const link = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=17/${lat}/${lng}`;

  return (
    <div className="overflow-hidden border border-[#E5E5E5]" data-testid="location-map">
      <iframe
        title="Standort Elvocom AG"
        src={src}
        className="h-[380px] w-full"
        loading="lazy"
        style={{ border: 0 }}
      />
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        data-testid="map-open-link"
        className="block bg-[#0A0A0A] px-4 py-3 text-center text-xs font-semibold uppercase tracking-wider text-white transition-colors hover:bg-[#E8620E]"
      >
        {label}
      </a>
    </div>
  );
};
